import { getEddyStatsQuery } from '../api/queries/getEddyStats';
import { graphQLClient } from '@/client/services/api/clients/graphqlClient';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

export const useGetEddyStats = () => {
  const { t } = useTranslation();

  return useQuery({
    queryKey: ['getEddyStats'],
    queryFn: async () => {
      const data = await graphQLClient.request(getEddyStatsQuery);

      return data.getEddyStats;
    },
    select: (selectData) => [
      {
        label: t('admin.aiAgent.stats.inAppPrompts'),
        value: selectData.inAppPromptCount,
      },
      {
        label: t('admin.aiAgent.stats.slackTeamsPrompts'),
        value: selectData.externalPromptCount,
      },
      {
        label: t('admin.aiAgent.stats.users'),
        value: selectData.eddyUserCount,
      },
      {
        label: t('admin.aiAgent.stats.positiveFeedback'),
        value: selectData.positiveSentimentCount,
      },
      {
        label: t('admin.aiAgent.stats.negativeFeedback'),
        value: selectData.negativeSentimentCount,
      },
    ],
  });
};
